import Save from '@mui/icons-material/Save'
import { Box, Fab, Zoom } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import ClinicHeader from 'src/clinic/components/ClinicHeader'
import { GenericHeaderBackButton } from 'src/consumer/components/UserActivityPage/MyPlanComponents'
import { ROLE_TYPES } from 'src/consumer/constants'
import { postDataWithoutParams } from 'src/consumer/services/featureServices'
import { ClinicDataContext } from 'src/context/ClinicDataContext'
import { SavingCircularProgress } from 'src/mentor/components/MentorProfilePage/MentorProfilePageStyles'
import { validateClinicFunction } from './clinic-schedule-utils'
import ClinicScheduleComponent from './components/ClinicScheduleComponent'

export default function ClinicSchedulePage() {
  const { clinicId } = useParams()
  const { chosenRoleFlow, ownerData, refreshOwnerAssociatedClinicsData } =
    useContext(ClinicDataContext)

  const thisClinicData = {
    ...ownerData?.associatedClinicsData?.find((item) => item?.id === clinicId),
    apiParam: 'clinic-profile',
  }

  console.log(ownerData)
  console.log(thisClinicData)

  const [formData, setFormData] = useState({})
  const [changesMade, setChangesMade] = useState(false)
  const [savingData, setSavingData] = useState(false)
  const [invalidSchedules, setInvalidSchedules] = useState([])

  function setData(prev) {
    setChangesMade(true)
    // setInvalidSchedules([])
    setFormData(prev)
  }

  async function handleSubmit(event) {
    setSavingData(true)
    const form = event.currentTarget
    if (form.checkValidity() === false) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      event.preventDefault()
      var toSubmit = formData
      var scheduleValidObjects = validateClinicFunction(formData)
      setInvalidSchedules(scheduleValidObjects.schedulesValidationArray)
      if (scheduleValidObjects.schedules) {
        const response = await postDataWithoutParams('/api/secure/cp/clinic/save', toSubmit)
        if (response.status === 200) {
          setChangesMade(false)
          refreshOwnerAssociatedClinicsData()
          toast.success('Schedules Saved Successfully')
          window.scrollTo(0, 0)
        } else {
          toast.error('Something went wrong while saving your schedule.')
        }
      }
    }
    setSavingData(false)
  }

  useEffect(() => {
    const clinicData = ownerData?.associatedClinicsData?.find((item) => item?.id === clinicId)
    setFormData({ ...clinicData, apiParam: 'clinic-profile' })
  }, [ownerData])

  if (chosenRoleFlow === ROLE_TYPES.roleClinicOwner) {
    return (
      <>
        <ClinicHeader
          heading={`Clinic Schedule:  ${thisClinicData?.title || ''}` || 'Clinic Schedule'}
        />
        <GenericHeaderBackButton
          clickfunction={() => window.history.back()}
          styles={{ margin: '20px' }}
        />
        <form
          onSubmit={handleSubmit}
          style={{ maxWidth: '870px', margin: '0 auto', padding: '16px 0px' }}
        >
          <ClinicScheduleComponent
            teacherData={formData}
            setTeacherData={setData}
            invalidSchedules={invalidSchedules}
          />
          <div
            style={{
              position: 'sticky',
              bottom: '16px',
              display: 'flex',
              flexDirection: 'row-reverse',
              alignItems: 'center',
              paddingTop: '16px',
            }}
          >
            <Zoom in={changesMade}>
              <Fab type="submit" disabled={savingData} sx={fabStyle} color="success">
                <Box sx={{ position: 'relative' }}>
                  {savingData && (
                    <SavingCircularProgress
                      size={24}
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-12px',
                      }}
                    />
                  )}
                </Box>
                <Save />
              </Fab>
            </Zoom>
          </div>
        </form>
      </>
    )
  }
}

const fabStyle = {}
